/**
 * Created by haoxianhuan on 2017/3/22.
 */

function rulesEvt(rules) {
    let flag = true;
    //是否必填

    if (rules.required) {
        flag = !!this.currentValue;
    }

    if (this.currentValue) {
      this.isError = true;
        if (rules.type && flag) {
            if (rules.type === 'number') flag = /^(-)?\d+(\.\d+)?$/.test(this.currentValue); //限定数字
            if (rules.type === 'int') flag = /^(-)?\d+$/.test(this.currentValue); //
            if (rules.type === 'chinese') flag = /^[\u4e00-\u9fa5]+$/.test(this.currentValue); //限定中文
            if (rules.type === 'money') flag = /^(([1-9]\d*)|0)(\.\d{1,2})?$/.test(this.currentValue); //金钱验证
            //时间格式
            if (rules.type === 'date') flag = /^((\d+\-){2}\d+)|((\d+\-){2}\d+(\s{1})\d{1,2}:\d{1,2}:\d{1,2})$/.test(this.currentValue);
        }

        if (rules.regex) { //依照正则验证
            flag = rules.regex.test(this.currentValue)
        }

        if ((typeof rules.max !== 'undefined' || typeof rules.min !== 'undefined') && flag) { //最大，最小字符长度
            let length = (this.currentValue + '').length;
            let f1 = true, f2 = true;
            if (typeof rules.max !== 'undefined') f1 = length <= rules.max;
            if (typeof rules.min !== 'undefined') f2 = length >= rules.min;
            flag = f1 && f2;
        }
    }

    if (!flag && this.valid) {
        this.valid = flag;
        this.messageError(rules.message)
    } else if (this.valid && flag) {
        this.messageError('')
    }

    //执行自定义函数验证
    if (rules.validator) {
        rules.validator.call(this, this.currentValue, this.messageError, this.errorMeg);
        if (this.errorMeg) this.valid = false;
    }
}

const mixin = {

    methods: {

        //分派事件与规则
        dispatchRules() {
            //from component or this 的rules属性提取
            let rules = (this.$parent.rules && this.$parent.rules[this.prop]) || this.rules;
            if (rules) {
                this.trigger(rules);
            }
        },
        //触发rulse > trigger 的绑定事件
        trigger(rules) {
            //注册此组件的事件
            for (let i = 0, len = rules.length; i < len; i++) {
                if (rules[i].trigger) {
                    let evt = rules[i].trigger.split(',');
                    for (let i = 0, len = evt.length; i < len; i++) {
                        if (this.CurrentEvents.indexOf(evt[i]) === -1) {
                            this.CurrentEvents.push(evt[i]);
                        }
                    }
                }
            }
            //触发绑定的事件
            for (let j = 0, length = this.CurrentEvents.length; j < length; j++) {
                this.$on(this.CurrentEvents[j], () => {
                    this.handleTrigger();
                })
            }
        },
        /**
         *  执行 rules
         */
        handleTrigger(fn) {
            this.valid = true;
            let rules = (this.$parent.rules && this.$parent.rules[this.prop]) || this.rules || [];
            for (let i = 0, lens = rules.length; i < lens; i++) {
                // 触发每个rules
                this.rulesEvt(rules[i]);
                if (fn) fn.call(this);
                if(!this.valid) break;
            }
        },
        /**
         *  错误信息
         * @param text
         */
        messageError(text) {
            this.errorMeg = text;
        },
        /**
         *  执行验证
         * @param rules
         */
        rulesEvt(rules) {
            // setTime out 模拟异步执行
            // setTimeout(()=>{
            rulesEvt.call(this, rules);
            // },0)
        }
    }
};

export default mixin;



// WEBPACK FOOTER //
// ./src/components/Form/mixin.js